import React, { forwardRef, MouseEventHandler, Ref, useCallback, useRef } from 'react';
import { Box, BoxSection } from 'components/_new/Box';
import { Overlay, OverlayElement } from 'components/_new/Overlay';
import { Button } from 'components/_new/Button';
import mergeRefs from 'merge-refs';
import { ImageElement, VideoElement } from 'components/_new/NewSlateEditor/types';
import { EmbedEditForm, EmbedEditFormData, useEmbedEditForm } from './EmbedEditForm';

type EmbedEditPopupProps = {
	element: ImageElement | VideoElement;
	onSave: (data: EmbedEditFormData) => void;
};

export const EmbedEditPopup = forwardRef(({ element, onSave }: EmbedEditPopupProps, ref: Ref<OverlayElement>) => {
	const { url, alt } = element;

	const editPopupRef = useRef<OverlayElement>(null);
	const [formState] = useEmbedEditForm({
		url,
		alt: alt && alt.length > 0 ? alt : undefined,
	});
	const [formData] = formState;

	const handleSaveClick: MouseEventHandler<HTMLButtonElement> = useCallback(() => {
		onSave({
			url: formData.url,
			alt: formData.alt && formData.alt.length > 0 ? formData.alt : undefined,
		});
		editPopupRef?.current?.close();
	}, [onSave, formData]);

	return (
		<Overlay ref={mergeRefs(editPopupRef, ref)}>
			<Box variant="white-bordered" className="editor-popup" dropShadow>
				<BoxSection>
					<EmbedEditForm formState={formState} />
					<div className="flex flex-row justify-content-end">
						<Button label="Zapisz" onClick={handleSaveClick} />
					</div>
				</BoxSection>
			</Box>
		</Overlay>
	);
});
